import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { generatePath } from 'react-router';
import util from 'util';
import constClass from '../../Constants/Constants';

const GuestOnly = (props) => {
  // static contextTypes = {
  //   router: PropTypes.object.isRequired
  // }
  const { user } = props;
  const history = useHistory();

  useEffect(() => {
    if (user.isLoggedIn) {
      if(Number(user.mallId) !== Number(props.match.params.mallId)){//ログインユーザの施設IDとURLの施設IDが異なる場合はログインユーザの施設を指定して遷移
        history.replace(generatePath(props.match.path, { siteId: props.match.params.siteId, mallId: user.mallId }));
        return;
      }
      const defaultpath = generatePath(props.match.path, { siteId: props.match.params.siteId, mallId: props.match.params.mallId });
      if (props.location.pathname === generatePath(props.children.props.path, { siteId: props.match.params.siteId, mallId: props.match.params.mallId })) {
        if (user.userClass === constClass.USER_CLASS.MANAGER) {
          history.replace(`${defaultpath}`);
        }
        else if (user.userClass === constClass.USER_CLASS.MANAGERMALL) {
          history.replace(`${defaultpath}user`);
        } else {
          history.replace(`${defaultpath}pointterminal`);
        }
      } else {
        const checkpath = props.location.pathname.substring(defaultpath.length).split("/")[0];
        if (user.userClass === constClass.USER_CLASS.STAFF && !constClass.SHOPUSER_PAGES.includes(checkpath)) {//店舗ユーザが許可されていないページを指定した場合はポイント履歴に遷移
          history.replace(`${defaultpath}pointterminal`);
        }
        else if (user.userClass === constClass.USER_CLASS.MANAGER && constClass.MANAGERMALL_PAGES.includes(checkpath)) {//施設管理者が施設責任者にのみ許可されているページを指定した場合はお客様一覧に遷移 
          history.replace(`${defaultpath}`);
        } 
      }
    }
  }, [user, history, props.location.pathname, props.children.props.path, props.match.path, props.match.params.siteId, props.match.params.mallId])

  return <div><div className="d-none">{util.inspect(props.location)}</div>{props.children}</div>;
}

GuestOnly.propTypes = {
  children: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

// function select({ auth }) {
//   return { auth };
// }

export default GuestOnly;